import { render, staticRenderFns } from "./HotelTransferPriceList.vue?vue&type=template&id=0a7f6752&"
import script from "./HotelTransferPriceList.vue?vue&type=script&lang=js&"
export * from "./HotelTransferPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports